'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import config from '../content/pages.json';
import { ExperienceProvider } from './Experience';
import { Navigation } from './Navigation';
import { CookiePreferences } from './CookiePreferences';
import TrFooter from '../content/pages/tr-footer';
import EnFooter from '../content/pages/en-footer';
import { routes } from '../lib/site';
import { buildLocalizedHref, resolveInternalPath, splitLocaleFromPathname } from '../../app/lib/routeUtils';
import { buildLanguageLinks } from '../lib/language-links';

export default function BrandShell({ locale, internalPath: initialInternalPath, children, languageLinks }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  // Locale layouts persist across Next.js client navigation. Resolve the current
  // page from the router so its panels, styles and animation state travel together.
  // Both public aliases and middleware-rewritten internal paths resolve here.
  const resolved = pathname == null
    ? { path: initialInternalPath, query: {} }
    : resolveInternalPath(locale, splitLocaleFromPathname(pathname).pathname);
  const internalPath = resolved.path;
  // Category aliases can reach the client as a rewritten integrations route.
  // Read router query state too, so language links follow category navigation.
  const category = searchParams?.get('category') || resolved.query?.category;
  const routeQuery = category ? { category } : resolved.query;
  const currentRoute = buildLocalizedHref(locale, internalPath, routeQuery);
  const entry = routes.find(r => r.internal === internalPath);
  const kind = entry?.kind || 'secondary';
  const page = config[`${locale}-${kind}`] || { groups: {}, panels: {} };
  const Footer = locale === 'en' ? EnFooter : TrFooter;
  // Server-provided CMS alternates belong only to the article that supplied them.
  const currentLanguageLinks = buildLanguageLinks(locale, internalPath, routeQuery,
    internalPath === initialInternalPath ? languageLinks : undefined);
  return <ExperienceProvider key={`${locale}-${internalPath}`} {...page} locale={locale} kind={kind} route={currentRoute} internalPath={internalPath} languageLinks={currentLanguageLinks}>
    <div className={`site-page ${kind} ${config[`${locale}-${kind}`] ? 'brand-core' : 'brand-secondary'}`} data-page={internalPath.split('/')[0] || 'home'}>
      <a className="skip-link" href="#page-content">{locale === 'en' ? 'Skip to content' : 'İçeriğe geç'}</a>
      <Navigation/><div id="page-content" tabIndex={-1}>{children}</div><Footer/><CookiePreferences/>
    </div>
  </ExperienceProvider>;
}

